import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import DtoDetailParamTransportRouteCode_ParamCarrier from "./DtoDetailParamTransportRouteCode_ParamCarrier";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 航线代码分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemParamTransportRouteCode extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 承运人
     */
    ParamCarrier?: DtoDetailParamTransportRouteCode_ParamCarrier;
    /**
     * 备注
     */
    Remarks?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 航线代码分页列表-项-表单校验
 */
export const DtoListItemParamTransportRouteCodeRules = {
}

/**
 * 航线代码分页列表-项-设置项
 */
export const DtoListItemParamTransportRouteCodeMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "NameZh",
    Label: "中文名称",
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
  },
  {
    Prop: "Code",
    Label: "代码",
  },
  {
    Prop: "FullName",
    Label: "全名",
  },
  {
    Prop: "ParamCarrier",
    Label: "承运人",
    Customize: true,
  },
  {
    Prop: "Remarks",
    Label: "备注",
  },
]
